export const ADDED_PRODUCT_POPUP_ID = 'added-product-popup';
